// 87.091.200 possible combinations
const YANO_CATEGORIES = [
    {
        name: "common-collections",
        categories: [
            { name: "3.2.1" },
            { name: "3.2" },
            { name: "3.1" },
            { name: "2..."}
        ]
    },
    {
        name: "commons-httpclient",
        categories: [
            { name: "3.1" },
            { name: "3.0.1" },
            { name: "2..." },
            { name: "3..." },
            { name: "3.0"},
        ]
    },
    {
        name: "joda-time",
        categories: [
            { name: "1.6" },
            { name: "2.2" },
            { name: "1.6.2" },
            { name: "2.0" },
            { name: "2.1" },
            { name: "2.3" },
            { name: "1.4" },
        ]
    }
];


// 1.036.800 possible combinations
const KOH_CATEGORIES = [
    {
        name: "Purchaser Currently Living In",
        categories: [
            { name: "Public Property" },
            { name: "Private Property" },
        ]
    },
    {
        name: "Property Type Purchased",
        categories: [
            { name: "Apartment" },
            { name: "Condominium" },
            { name: "Detached" },
            { name: "Exec Condominium" },
            { name: "Semi-Detached"},
            { name: "Terraced House" },
        ]
    },
    {
        name: "Location of Purchased Property",
        categories: [
            { name: "Central" },
            { name: "East" },
            { name: "North-East" },
            { name: "North" },
            { name: "West"},
        ]
    }
];

// 144 possible combinations
const ROGERS_2_CATEGORIES = [
    {
        name: "Participant",
        categories: [
            { name: "D" },
            { name: "E" },
        ]
    },
    {
        name: "Origin",
        categories: [
            { name: "Prompted" },
            { name: "Spontaneous" },
        ]
    },
    {
        name: "Touch Location",
        categories: [
            { name: "Torso" },
            { name: "Other" },
            { name: "Hands" },
        ]
    }
];

// 432 possible combinations
export const ROGERS_1_CATEGORIES = [
    {
        name: "Participant",
        categories: [
            { name: "A" },
            { name: "B" },
            { name: "C" },
        ]
    },
    {
        name: "Origin",
        categories: [
            { name: "Prompted" },
            { name: "Spontaneous" },
        ]
    },
    {
        name: "Touch Location",
        categories: [
            { name: "Torso" },
            { name: "Other" },
            { name: "Hands" },
        ]
    }
];

// 288 possible combinations
const SCHAETZLE_CATEGORIES = [
    {
        name: "voice",
        categories: [
            { name: "middle" },
            { name: "active" },
            { name: "..." },
        ]
    },
    {
        name: "word_order",
        categories: [
            { name: "SVO1" },
            { name: "VSO1" },
            { name: "O1VS" },
            { name: "..." },
        ]
    },
];

// 2.488.320 possible combinations
const HASSAN_CATEGORIES = [
    {
        name: "Value",
        categories: [
            { name: "Critical" },
            { name: "Unknown" },
            { name: "Non Critical" },
        ]
    },
    {
        name: "Sensitivity",
        categories: [
            { name: "High" },
            { name: "Low" },
            { name: "Unknown" },
        ]
    },
    {
        name: "Region",
        categories: [
            { name: "Asia Pacific (Tokyo)" },
            { name: "US West (Northern California)" },
            { name: "Asia Pacific (Sydney)" },
            { name: "South America (Sao Paulo)" },
            { name: "EU (Ireland)" },
        ]
    },
    {
        name: "Costs",
        categories: [
            { name: "Very High" },
            { name: "High" },
            { name: "Low" },
            { name: "Moderate" },
        ]
    },
];

// 4578 possible combinations
const TITANIC_CATEGORIES = [
    {
        name: "Survived",
        categories: [
            { name: "Survived" },
            { name: "Perished" },
        ]
    },
    {
        name: "Sex",
        categories: [
            { name: "Female" },
            { name: "Male" },
        ]
    },
    {
        name: "Age",
        categories: [
            { name: "Child" },
            { name: "Adult" },
        ]
    },
    {
        name: "Class",
        categories: [
            { name: "Second Class" },
            { name: "First Class" },
            { name: "Third Class" },
            { name: "Crew" },
        ]
    },
];

export const DATASETS = {
    YANO: { name: 'yano', label: 'Yano', categories: YANO_CATEGORIES},
    KOH: { name: 'koh', label: 'Koh', categories: KOH_CATEGORIES },
    ROGERS_2: { name: 'rogers-2', label: 'Rogers 2', categories: ROGERS_2_CATEGORIES },
    ROGERS_1: { name: 'rogers-1', label: 'Rogers 1', categories: ROGERS_1_CATEGORIES },
    SCHAETZLE: { name: 'schaetzle', label: 'Schätzle', categories: SCHAETZLE_CATEGORIES },
    HASSAN: { name: 'hassan', label: 'Hassan', categories: HASSAN_CATEGORIES },
    TITANIC: { name: 'titanic', label: 'Titanic', categories: TITANIC_CATEGORIES},
}

export function retrieveDatasetData(name) {
    switch (name) {
        case 'yano':
            return DATASETS.YANO;
        case 'koh':
            return DATASETS.KOH;
        case 'rogers-2':
            return DATASETS.ROGERS_2;
        case 'rogers-1':
            return DATASETS.ROGERS_1;
        case 'schaetzle':
            return DATASETS.SCHAETZLE;
        case 'hassan':
            return DATASETS.HASSAN;
        case 'titanic':
            return DATASETS.TITANIC;
        default:
            throw Error('No such dataset');
    }
}

// Original ordering (todo/04 D1): the configuration the tool shows on a fresh load, [{ name, categories: [names] }].
// Checked against the published figures: results/reproduction/original_orderings.md in the parent repository.
export function originalConfig(name) {
    return retrieveDatasetData(name).categories.map(a => ({ name: a.name, categories: a.categories.map(c => c.name) }));
}
